import { render } from "./IVk.vue?vue&type=template&id=1cb79aa5"
import script from "./IVk.vue?vue&type=script&lang=js"
export * from "./IVk.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__